export default __webpack_public_path__ + "static/6-f537abafbaa7e7f75d23bd19b5dd2f5c.jpg";